import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { userReducer } from 'User/reduxUser';
import { educationReducer } from 'Education/reduxEducation';

const createRootReducer = history =>
    combineReducers({
        router: connectRouter(history),
        user: userReducer,
        education: educationReducer,
    });

export default createRootReducer;
